import { returnAction } from '../return-action.util';
import { ActionEnum } from '../../../enum/action.enum';
import { IDeleteCustomListEntryPayload } from '../../../action/custom-lists.action';

export const deleteCustomListEntry = (customListEntryId: string) => returnAction<IDeleteCustomListEntryPayload>(ActionEnum.DELETE_CUSTOM_LIST_ENTRY, {customListEntryId: customListEntryId});
